import { eElement } from "./Issues";

export type tTeamMember = {
    id: number;
    name: string;
    description: string;
    skill: eElement;
    level: number;
    icon: string;
    currentlyEmployed: boolean;
}

// create an exported team const that has an array of team members.  Create four members.  One should be a UI developer, one should be a backend developer, one should be a database developer, and one should be a DevOps developer.  Give each member a unique id, name, description, skill, and icon.  The icon can be a person emoji.
export const team: tTeamMember[] = [
    // Original four developers (currently employed)
    {
        id: 1,
        name: 'Sally String',
        description: 'Frontend developer that specializes in UI/UX design',
        skill: eElement.UI,
        icon: '👱‍♀️',
        level: 1,
        currentlyEmployed: true,
    },
    {
        id: 2,
        name: 'Barry Boolean',
        description: 'Backend developer that specializes in API development',
        skill: eElement.API,
        icon: '🧔‍♂️',
        level: 1,
        currentlyEmployed: true,
    },
    {
        id: 3,
        name: 'Fred Float',
        description: 'Database developer that specializes in database design and optimization',
        skill: eElement.Db,
        icon: '👨🏾‍🦱',
        level: 1,
        currentlyEmployed: true,
    },
    {
        id: 4,
        name: 'Ingrid Integer',
        description: 'DevOps developer that specializes in infrastructure, deployment, and QA',
        skill: eElement.DevOps,
        icon: '👩🏽',
        level: 1,
        currentlyEmployed: true,
    },
    // Additional eight developers (not yet employed)
    {
        id: 5,
        name: 'Charlie Char',
        description: 'Frontend developer with a passion for responsive design',
        skill: eElement.UI,
        icon: '🧑‍🦰',
        level: 0.75,
        currentlyEmployed: false,
    },
    {
        id: 6,
        name: 'Betty Byte',
        description: 'Backend developer specializing in microservices architecture',
        skill: eElement.API,
        icon: '👩‍🦳',
        level: 1.25,
        currentlyEmployed: false,
    },
    {
        id: 7,
        name: 'Danny Decimal',
        description: 'Database developer expert in SQL optimization',
        skill: eElement.Db,
        icon: '👨‍🦲',
        level: 0.5,
        currentlyEmployed: false,
    },
    {
        id: 8,
        name: 'Oscar Object',
        description: 'DevOps engineer focused on CI/CD pipelines',
        skill: eElement.DevOps,
        icon: '🧑‍🦱',
        level: 1,
        currentlyEmployed: false,
    },
    {
        id: 9,
        name: 'Nancy Null',
        description: 'Frontend developer skilled in animation and interactions',
        skill: eElement.UI,
        icon: '👩‍🦰',
        level: 1.25,
        currentlyEmployed: false,
    },
    {
        id: 10,
        name: 'Perry Pointer',
        description: 'Backend developer with expertise in RESTful APIs',
        skill: eElement.API,
        icon: '👨‍🦳',
        level: 0.5,
        currentlyEmployed: false,
    },
    {
        id: 11,
        name: 'Trudy Table',
        description: 'Database developer specializing in data modeling',
        skill: eElement.Db,
        icon: '👩🏻',
        level: 0.75,
        currentlyEmployed: false,
    },
    {
        id: 12,
        name: 'Kenny Key',
        description: 'DevOps engineer expert in cloud infrastructure',
        skill: eElement.DevOps,
        icon: '🧑🏽',
        level: 1,
        currentlyEmployed: false,
    },
]